let search_page_total_records = 0;

function createHTML(htmlString) {
    return { __html: htmlString };
}
document.addEventListener('algolia.hooks.initialize', function() {
    algoliaShopify.hooks.registerHook('beforeAutocompleteOptions', function(options) {
      // Change the placeholder text of the autocomplete menu
      options.insights= true;
      if(new URL(window.location).searchParams.get('q')){
        options.initialState =  {query: new URL(window.location).searchParams.get('q')};
      }
      options.openOnFocus = true;

      options.placeholder =  "Search Products & Collections";
      return options;
    });
});